
import React from "react";
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { FileText } from "lucide-react";

interface MessageCardProps {
  message?: string;
}

const MessageCard: React.FC<MessageCardProps> = ({ message }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-medium flex items-center">
          <FileText className="h-5 w-5 mr-2 text-reagent-blue" />
          Message
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="whitespace-pre-wrap">
          {message || "No message provided with this swap request."}
        </p>
      </CardContent>
    </Card>
  );
};

export default MessageCard;
